import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { FC, useId } from 'react';
import css from './style.module.scss';
interface Props {
  className?: string;
}
const AnimatedGradientRing: FC<Props> = t0 => {
  const $ = _c(30);
  const {
    className
  } = t0;
  const t1 = useId();
  let t2;
  if ($[0] !== t1) {
    let t3;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = /:/g;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    t2 = t1.replace(t3, "");
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const ringId = t2;
  let t3;
  if ($[3] !== className) {
    t3 = clsx(css.root, className);
    $[3] = className;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `${ringId}-fill`;
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <stop stopColor="#111111" />;
    t6 = <stop offset="1" stopColor="#242323" />;
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t4) {
    t7 = <radialGradient id={t4} cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(82.8501 82.8501) rotate(90) scale(82.5 87.6773)">{t5}{t6}</radialGradient>;
    $[7] = t4;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = `${ringId}-stroke`;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <stop stopColor="#4F4F4F" />;
    t10 = <stop offset="0.310901" stopColor="#8A38F5" />;
    t11 = <stop offset="0.524776" stopColor="#8A38F5" />;
    t12 = <stop offset="0.693571" stopColor="#8A38F5" />;
    t13 = <stop offset="1" stopColor="#9BFF00" />;
    t14 = <animateTransform attributeName="gradientTransform" type="rotate" from="0 82.8501 82.8501" to="360 82.8501 82.8501" dur="8s" repeatCount="indefinite" />;
    $[9] = t10;
    $[10] = t11;
    $[11] = t12;
    $[12] = t13;
    $[13] = t14;
    $[14] = t9;
  } else {
    t10 = $[9];
    t11 = $[10];
    t12 = $[11];
    t13 = $[12];
    t14 = $[13];
    t9 = $[14];
  }
  let t15;
  if ($[15] !== t8) {
    t15 = <linearGradient id={t8} x1="-24.6419" y1="140.095" x2="164.611" y2="139.965" gradientUnits="userSpaceOnUse">{t9}{t10}{t11}{t12}{t13}{t14}</linearGradient>;
    $[15] = t8;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  let t16;
  if ($[17] !== t15 || $[18] !== t7) {
    t16 = <defs>{t7}{t15}</defs>;
    $[17] = t15;
    $[18] = t7;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  const t17 = `url(#${ringId}-fill)`;
  let t18;
  if ($[20] !== t17) {
    t18 = <circle cx="82.8501" cy="82.8501" r="82.5" fill={t17} />;
    $[20] = t17;
    $[21] = t18;
  } else {
    t18 = $[21];
  }
  let t19;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <circle className={css.dash} cx="82.8501" cy="82.8501" r="82.5" stroke="white" strokeWidth="0.7" strokeDasharray="4 4" />;
    $[22] = t19;
  } else {
    t19 = $[22];
  }
  const t20 = `url(#${ringId}-stroke)`;
  let t21;
  if ($[23] !== t20) {
    t21 = <circle className={css.dash} cx="82.8501" cy="82.8501" r="82.5" stroke={t20} strokeWidth="0.7" strokeDasharray="4 4" />;
    $[23] = t20;
    $[24] = t21;
  } else {
    t21 = $[24];
  }
  let t22;
  if ($[25] !== t16 || $[26] !== t18 || $[27] !== t21 || $[28] !== t3) {
    t22 = <svg aria-hidden={true} className={t3} viewBox="0 0 166 166" fill="none">{t16}{t18}{t19}{t21}</svg>;
    $[25] = t16;
    $[26] = t18;
    $[27] = t21;
    $[28] = t3;
    $[29] = t22;
  } else {
    t22 = $[29];
  }
  return t22;
};
export default AnimatedGradientRing;